import { BoxTitles } from "@boxes/BoxTitles";
import { BoxTypes } from "@boxes/BoxTypes";
import { BoxValidations } from "@boxes/BoxValidations";
import style from "@styles/pages/flow/boxes/Box.module.scss";
import { memo } from "react";
import { ReportFooter } from "../layout/ReportFooter";
import SourceBaseBox from "../layout/SourceBaseBox";

export default memo(({ id, data, selected, isConnectable }) => {
  return (
    <SourceBaseBox
      title={BoxTitles.SavedAudience}
      valid={BoxValidations.validate(BoxTypes.SavedAudience, data)}
      selected={selected}
      isConnectable={isConnectable}
      footer={<ReportFooter id={id} />}
    >
      {data?.name && <div className={style.subline}>{data?.name}</div>}
    </SourceBaseBox>
  );
});
